import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import SidebarAppBanner from 'components/Sidebar/AppBanner';
import SidebarFeaturedSubcategories from 'components/Sidebar/FeaturedSubcategories';
import SidebarLatestCoupons from 'components/Sidebar/LatestCoupons';
import SidebarOffersList from 'components/Sidebar/OffersList';
import SidebarSocialMedia from 'components/Sidebar/SocialMedia';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const OffersPageSidebar = ({
  topOffers = [],
  withFeaturedSubcategories = false,
}) => {
  const latestCouponRef = useRef(null);
  const topOffersRef = useRef(null);

  return (
    <Sidebar
      className="space-y-4"
      refsToBeIgnoredBeforeFixing={[latestCouponRef, topOffersRef]}
    >
      <SidebarLatestCoupons ref={latestCouponRef} />
      {topOffers.length > 0 && (
        <SidebarOffersList
          ref={topOffersRef}
          linkProps={{
            children: placeholder('actions.seeAllOffers'),
            href: LINKS.HOME,
          }}
          offers={topOffers}
          title={placeholder('titles.topOffers')}
        />
      )}
      {withFeaturedSubcategories && <SidebarFeaturedSubcategories />}
      <SidebarAppBanner />
      <SidebarSocialMedia />
    </Sidebar>
  );
};

OffersPageSidebar.propTypes = {
  topOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ),
  withFeaturedSubcategories: PropTypes.bool,
};

export default OffersPageSidebar;
